import styled from 'styled-components';

export const DarkFooter = styled.div`
    background: var(--dark);
`;

export const DarkMainFooter = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;
`;
